(function () {
  if (window.__kkareRelatedContentTracking) return;
  window.__kkareRelatedContentTracking = true;

  function publish(eventName, parameters) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, parameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, parameters));
    }
    window.dispatchEvent(new CustomEvent('kkare:' + eventName, { detail: parameters }));
  }

  function viewParameters(module) {
    return {
      source_article: module.getAttribute('data-source-article') || '',
      content_cluster: module.getAttribute('data-content-cluster') || '',
      language: document.documentElement.lang || ''
    };
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('[data-kk-event="related_content_click"]');
    if (!target) return;

    var parameters = {
      source_article: target.getAttribute('data-source-article') || '',
      destination_url: target.getAttribute('data-destination-url') || target.getAttribute('href') || '',
      destination_title: target.getAttribute('data-destination-title') || '',
      content_cluster: target.getAttribute('data-content-cluster') || '',
      recommendation_type: target.getAttribute('data-recommendation-type') || '',
      card_position: target.getAttribute('data-card-position') || '',
      language: target.getAttribute('data-language') || document.documentElement.lang || ''
    };

    publish('related_content_click', parameters);
  }, true);

  var modules = Array.prototype.slice.call(document.querySelectorAll('[data-related-content-module]'));
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35 || entry.target.__kkareRelatedSeen) return;
        entry.target.__kkareRelatedSeen = true;
        publish('related_content_view', viewParameters(entry.target));
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.35] });
    modules.forEach(function (module) { observer.observe(module); });
  }
})();
